import {Typography} from "@mui/material";
import {Outlet} from "react-router-dom";


const NewOrgRoute = () => {
    return (
        <Outlet/>
    )
}

export default NewOrgRoute;